// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

/* ------------------------------------------------------------------------------------------ */
/* Based on the "Color Tokens" view -------------------------------------------------- */
/* ------------------------------------------------------------------------------------------ */

const colors: Styleguide["colors"] = {
    primary: {
        main: "#00539b", // Primary -> Main
        contrast: "#ffffff", // None, look at primary button text color
        light: "#0e82e6", // Primary -> Light
        dark: "#1a3a69", // Primary -> Dark
    },
    secondary: {
        main: "#3b94d1", // Secondary -> Main
        contrast: "#ffffff", // None, look at secondary button text color
        light: "#86ceff", // Secondary -> Light
        dark: "#2a6d9b", // Secondary -> Dark
    },
    tertiary: {
        main: "#ecb020", // Tertiary -> Main
        contrast: "#ffffff", // None, look at tertiary button text color
        light: "#ffcf5b", // Tertiary -> Light
        dark: "#cd9819", // Tertiary -> Dark
    },
    common: {
        border: "#e1e2e7", // Black & White -> Border
        borderLight: "#f7f8fc", // Gray Shades -> Light
        borderDark: "#6f7074", // Gray Shades -> Main
        accent: "#f7f8fc", // Gray Shades -> Light
        accentContrast: "#303030", // Text Color -> Main
        accentContrastLight: "#6f7074", // Gray Shades -> Main
        background: "#ffffff", // None, look at website background color
        backgroundContrast: "#303030", // Text Color -> Main
        disabled: "#f7f8fc", // Gray Shades -> Light
        disabledDark: "#d6d7dc", // Gray Shades -> Mid
    },
    text: {
        main: "#303030", // Text Color -> Main
        accent: "#6f7074", // Text Color -> Accent
        disabled: "#a8a8a8", // Text Color -> Semi
        link: "#00539b", // Primary -> Main
        linkHover: "#1a3a69", // Primary -> Dark
        linkAlt: "#303030", // Text Color -> Main
        linkAltHover: "#00539b", // Primary -> Main
        input: "#303030", // Text Color -> Main
        // Store Custom Code
        salePrice: "#df3258", // Text Color -> Sale Prices
    },
    success: {
        main: "#11916d", // Alerts/Contrast -> Success
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Success" token
        light: "#e4f5f4", // Alerts/Light -> Success
    },
    warning: {
        main: "#ce7633", // Alerts/Contrast -> Warning
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Warning" token
        light: "#fff5e9", // Alerts/Light -> Warning
    },
    danger: {
        main: "#df3258", // Alerts/Contrast -> Error
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Error" token
        light: "#f5e8ea", // Alerts/Light -> Error
    },
    info: {
        main: "#1985c9", // Alerts/Contrast -> Info
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Info" token
        light: "#f0faff", // Alerts/Light -> Info
    },
    neutral: {
        main: "#666666", // None
        contrast: "#ffffff", // None
        light: "#e0e0e0", // None
    },
    invert: {
        main: "#ffffff", // None
        contrast: "#00539b", // Primary -> Main
        hover: "#1a3a69", // Primary -> Dark
        dark: "#ececec", // None
    },
    placeholder: {
        main: "#6f7074", // Text Color -> Accent
        disabled: "#d6d7dc", // Gray Shades -> Mid
    },
    button: {
        disabled: {
            main: "#d6d7dc", // Gray Shades -> Mid
            contrast: "#ffffff", // Black & White -> White
        },
    },
    header: {
        main: "#00539b", // None, look at header background color
        contrast: "#ffffff", // Text Color -> Main
        hover: "#ffffff", // Primary -> Dark
        accent: "#ffffff", // Primary -> Main
        accentHover: "#ffffff", // Primary -> Dark
        accentContrast: "#00539b", // None, should match "primary.contrast"
    },
    menu: {
        mainNavigation: {
            main: "#1a3a69", // None, look at main navigation background color
            contrast: "#ffffff", // Text Color -> Main
            hover: "#ffffff", // Primary -> Main
            underline: "#ffffff", // Primary -> Main
            accent: "#ffffff", // Primary -> Main
            accentContrast: "#1a3a69", // None, should match "primary.contrast"
            accentHover: "#ffffff", // Primary -> Main
            separator: "#00539b", // Black & White -> Border
            border: "#1a3a69", // Black & White -> Border
        },
        secondaryNavigation: {
            main: "#00539b", // Primary -> Dark
            contrast: "#ffffff", // None, should match "primary.contrast"
            hover: "#ffffff", // None, should match "primary.contrast"
        },
    },
    footer: {
        main: "#00539b", // Gray Shades -> Light
        contrast: "#ffffff", // Text Color -> Main
        alt: "#1a3a69", // Primary -> Dark
        altContrast: "#ffffff", // None, should match "primary.contrast"
    },
    swatch: {
        main: "#e1e2e7", // Black & White -> Border
        contrast: "#303030", // Text Color -> Main
        hover: "#00539b", // Primary -> Main
        selected: "#00539b", // Primary -> Main
        selectedHover: "#1a3a69", // Primary -> Dark
    },
};

export default colors;
